import clsx from 'clsx';
import { formatUrl } from 'next/dist/shared/lib/router/utils/format-url';
import NextLink from 'next/link';
import { type ComponentProps, type FC } from 'react';

import styles from './Link.module.scss';

export type LinkProps = ComponentProps<typeof NextLink> & {
  isOutsideLink?: boolean;
};

export const Link: FC<LinkProps> = (props) => {
  const { className, href, isOutsideLink, children, onClick, ...linkProps } = props;

  const commonLinkProps = {
    className: clsx(styles.root, className),
    children,
    onClick,
  };

  if (isOutsideLink) {
    return (
      <a
        href={typeof href === 'string' ? href : formatUrl(href)}
        target={linkProps.target}
        rel={linkProps.rel}
        {...commonLinkProps}
      />
    );
  }

  return (
    <NextLink href={href} {...linkProps}>
      <a {...commonLinkProps} />
    </NextLink>
  );
};
